import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=069e924a&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=069e924a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e924a",
  null
  
)

export default component.exports